// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3941":"css/admin-app.6725","9869":"css/app.6725"}[chunkId] + ".css";
};